<template>
    <!-- 外层容器：设置全局背景色 -->
    <div class="protocol-page-wrapper">
        <!-- 主体容器：保持原有宽度 -->
        <div class="protocol-container">
            <el-button type="text" @click="goLogin" style="float: left;color: #999;" icon="el-icon-arrow-left">
                返回登录页
            </el-button>
            <div class="protocol-header">
                <h1>智步云上模型网服务协议</h1>
            </div>
            <div class="protocol-content">
                <!-- 这里放置服务协议的具体内容 -->
                <div class="protocol-section">
                    <p>感谢您（即在智步云上模型网上交易平台注册的用户）选择智步云上模型网上交易平台为您提供服务。《智步云上模型网上交易平台服务协议》（以下简称“本协议”）由北京智步云上科技有限公司（以下简称“我们”）和您签订。</p>
                    <h2>一、协议的确认</h2>
                    <p>1.1您在使用智步云上模型网上交易平台服务之前，应当认真阅读本协议，请您务必审慎阅读、充分理解本协议中相关条款内容，尤其是字体加粗部分、免除或者限制责任的条款、争议解决和法律适用条款。如您对本协议有任何疑问，您可通过智步云上模型网上交易平台客服进行咨询，以便我们为您解释和说明。
                    </p>
                    <p>1.2当您按照注册页面提示填写信息，阅读并同意本协议或其他方式确认即表示您已充分阅读、理解并接受本协议的全部内容，并与智步云上模型网上交易平台达成本协议。本协议内容包括协议正文及所有智步云上模型网上交易平台已经发布的各类规则，所有规则与本协议正文具有同等法律效力。您承诺接受并遵守本协议的约定，届时您不应以未阅读本协议的内容主张本协议无效，或要求撤销本协议。如您不同意本协议将导致我们无法为您提供完整的服务，您也可以选择停止使用。如果您未申请注册流程，或者在本协议生效前已成为智步云上模型网上交易平台的注册用户，则您通过访问和/或使用智步云上模型网上交易平台，即视为您表示同意接受本协议的全部内容，否则请您停止访问或使用智步云上模型网上交易平台。
                    </p>
                    <p>1.3
                        智步云上模型网上交易平台有权根据需要不时地制定、修改本协议或各类规则，如我们对本协议进行修改，我们将通过http://swocs.com.cn/model/网站（如果将来我们变更网址或增加其他网址，请以届时的网址为准）予以公布，经修订的协议一经公布立即自动生效。若您无法同意变更修改后的协议内容，您有权停止使用相关服务，如您继续使用服务，则将视为您已接受经修订的条款。当您与智步云上模型网上交易平台发生争议时，应以最新的条款为准，双方协商一致的，也可另行以书面形式变更相关服务和对应协议内容。
                    </p>
                    <p>1.4
                        智步云上模型网上交易平台（http://swocs.com.cn/model/）是北京智步云上科技有限公司旗下运营的专业原创数字创意作品供应平台和定制服务平台。智步云上模型网上交易平台作为原创数字创意作品网络服务平台，以诚信服务为宗旨，以便捷高效为目标，智步云上模型网上交易平台不作为交易方，也不上传任何作品，仅为交易双方提供第三方网络平台服务。智步云上模型网上交易平台提供的各项电子服务的所有权、经营管理权、运营权及最终解释权归北京智步云上科技有限公司所有。
                    </p>
                    <p>1.5本协议旨在促进开放、透明、分享、责任的商业规则，保障智步云上模型网上交易平台用户的合法权益，创建、维护和谐的网络商业环境。</p>
                    <p>1.6您在使用智步云上模型网上交易平台服务中的所有行为均应遵守国家法律、行政法规、部门规章等规范性文件以及与智步云上模型网上交易平台签署的相关协议，不违背社会公共利益或者公共道德，不损害他人的合法权益，不违反本协议及相关规则与规定。
                    </p>

                </div>
                <div class="protocol-section">
                    <h2>二、协议范围</h2>
                    <p>2.1本协议由您与智步云上模型网上交易平台（北京智步云上科技有限公司）共同缔结，本协议对您与智步云上模型网上交易平台均具有约束力和合同效力。</p>
                    <p>2.2除另行明确声明外，本协议阐述之条款和条件适用于您使用智步云上模型网上交易平台（以网站、客户端、小程序以及随技术发展出现的新形态）时我们向您提供的各项服务，同时任何使服务范围扩大或功能增强的新内容亦无条件地受本协议约束，包括新产品及新增的服务或功能。
                    </p>
                    <p>2.3本协议不涉及您与智步云上模型网上交易平台其它用户之间因网上交易而产生的法律关系及法律纠纷。</p>
                </div>
                <div class="protocol-section">
                    <h2>三、账号注册与使用</h2>
                    <p>3.1 用户主体资格</p>
                    <p>您确认，在您开始注册程序使用智步云上模型网上交易平台服务前，您应是符合下列条件之一的自然人、法人或其他组织。否则您应当停止使用智步云上模型网上交易平台服务，同时您理解违反下列要求可能会造成您无法正常注册及使用智步云上模型网上交易平台服务。
                    </p>
                    <p>3.1.1根据中华人民共和国法律规定年满18周岁或16周岁以上（含本数）不满18周岁但以自己的劳动收入为主要生活来源的，具备完全民事行为能力的自然人或根据本国法律规定具有完全民事行为能力的外国自然人。
                    </p>
                    <p>3.1.2无民事行为能力人、限制民事行为能力人应经其监护人同意，并且监护人已经代表您成为用户。</p>
                    <p>3.1.3根据中华人民共和国法律、法规、行政规章或外国法律成立并合法存续的公司、企事业单位、社团组织和其他组织。未经批准设立的组织不能注册为智步云上模型网上交易平台用户。</p>
                    <p>3.2 账号相关说明</p>
                    <p>3.2.1 用户注册</p>
                    <p>智步云上模型网上交易平台为您提供了注册通道，当您按照注册页面提示填写信息、阅读并同意本协议并完成全部注册程序后可获得智步云上模型网上交易平台账号，您注册的智步云上模型网上交易平台账号的所有权归智步云上模型网上交易平台所有，完成注册申请手续后，您获得智步云上模型网上交易平台账号的使用权。
                    </p>
                    <p>您应自行向智步云上模型网上交易平台提供注册资料，确保提供的注册资料（包括但不限于个人信息、联系地址、联系电话、电子邮箱、QQ等）真实、准确、完整、合法有效，您注册资料如有变动的，应及时更新。如因您所提供的注册资料不合法、不真实、不准确或未及时更新从而导致相关法律责任或不利后果的，您将承担相应的法律责任及不利后果，或我们有理由怀疑为错误、不实或不合法的资料，则我们有权拒绝为您提供相关服务，您可能无法使用我们服务及相关服务或在使用过程中部分功能受到限制。
                    </p>
                    <p>3.2.2 账号安全</p>
                    <p>（1）您应谨慎合理的保存并使用用户名、昵称、头像和密码，不得将在智步云上模型网上交易平台注册获得的账号以任何形式赠与、借用、出租、转让、售卖或以其他方式许可他人使用，否则您应承担由此产生的全部责任，并赔偿由此给智步云上模型网上交易平台造成的所有损失（包括但不限于直接损失、间接损失及维权支付的律师费用、保全费用、公证费用等合理费用），并与实际使用人承担连带责任。
                    </p>
                    <p>（2）如果我们发现或者有合理理由认为使用者并非账号初始注册人，为保障账号安全，我们有权立即暂停或终止向该账号提供服务，有权冻结该账户，并有权永久禁用该账号。如果发现任何人不当使用您的账号或有任何其他可能危及您账号安全的情形时，您应当立即以有效方式通知智步云上模型网上交易平台，要求智步云上模型网上交易平台暂停或终止相关服务。
                    </p>
                    <p>（3）您的用户名、头像和简介等信息不得侵犯或涉嫌侵犯他人的姓名权（名称权）、肖像权、名誉权、荣誉权等合法权益，不得冒用关联机构或社会名人。也不得包含法律、法规、行政规章等规定禁止使用的信息，不得涉及官媒、党政、色情、恐怖暴力、封建迷信等违法信息以及含有智步云上模型网上交易平台、版主、管理员等词汇，否则我们有权立即暂停或终止向该注册账号提供服务并要求您修改。
                    </p>
                    <p>您同意并授权，为了更好的为您提供服务以及确保您的账户安全，智步云上模型网上交易平台可以根据您提供的手机号码、身份证号码等信息，在法律法规允许和协议约定的范围内，向全国公民身份号码查询服务中心、电信运营商、金融服务机构等可靠单位发起用户身份真实性、用户征信记录、用户手机号码有效性状态等情况的查询。
                    </p>
                    <p>3.2.3 实名认证</p>
                    <p>为我们更好地为您提供服务，确保您的账号安全，您应按照中华人民共和国法律法规的规定和智步云上模型网上交易平台的要求完成实名认证。我们对您提交的注册信息和认证信息予以保护，不会将其披露给任何非关联的第三方，除非：
                    </p>
                    <p>（1）相关法律法规或国家机关要求；</p>
                    <p>（2）我们发生相关合并、分立、收购或资产转移；</p>
                    <p>（3）为提供相关服务所必需。</p>
                    <p>3.2.4 账号注销</p>
                    <p>如您决定终止在智步云上模型网上交易平台上的所有业务，应向智步云上模型网上交易平台提出账号注销申请。在满足智步云上模型网上交易平台关于账号注销条件时，您可以联系客服注销您的账号，经智步云上模型网上交易平台审核同意的可以注销您的账号，届时您与智步云上模型网上交易平台基于本协议的合同关系即终止。您的账号被注销后，智步云上模型网上交易平台没有义务为您保留或向您披露您账号中的任何信息，但您仍应对您在注销账号前且使用我们服务期间的行为承担相应责任。
                    </p>
                    <p>具体操作请查看 《智步云上模型网上交易平台账户注销须知》</p>

                </div>
                <div class="protocol-section">
                    <h2>四、用户的权利与义务</h2>
                    <p>4.1您有权根据本协议及智步云上模型网上交易平台发布的相关规则使用智步云上模型网上交易平台提供的服务，智步云上模型网上交易平台不承担因您不遵守本协议及相关规则而发生的任何损失。您可以通过智步云上模型网上交易平台提供的服务在智步云上模型网上交易平台上传、发布、传输、出售作品，您应确保是作品的原创者或已取得相关授权的权利人。您需保证对上传到智步云上模型网上交易平台上的作品拥有完整的著作权，同时保证上传的作品不侵犯或违反第三方的版权、专利权、商标权、商业秘密、隐私权、名誉权、肖像权、物权、公开权或其它知识产权或专有权利。并且，如果有第三方对您提交的作品提出权利质疑，您需要向智步云上模型网上交易平台提交作品权属声明文件，您需对声明内容真实性负责并承担相关的法律责任。 
                    </p>
                    <p>如您无异议，您使用智步云上模型网上交易平台上传、发布、传输、出售作品即视为您同意授权智步云上模型网上交易平台对您的作品代为主动维权，智步云上模型网上交易平台因此支出的维权成本，包括必要的律师费用、取证费用和诉讼费用，从对您的作品进行主动维权所得赔偿中支出。
                    </p>
                    <p>4.2您应妥善保管好您的智步云上模型网上交易平台账号和密码，且您有权根据需要修改相关密码，并对您账号下发生的所有活动（包括但不限于发布信息、评论、回复或出售、购买作品或网上点击同意各类协议、规则等）承担责任。您承诺并同意：若发现您的用户名和密码被盗用，应立即书面通知智步云上模型网上交易平台。您应确保使用智步云上模型网上交易平台服务时处于安全的网络环境并以正确步骤退出。
                    </p>
                    <p>4.3您承诺并同意不得将自己的智步云上模型网上交易平台账号、密码通过任何方式给予他人使用。因黑客行为或您的保管疏忽导致账号、密码遭他人非法使用而造成的损失，由您或非法使用者承担责任，智步云上模型网上交易平台不承担任何责任。
                    </p>
                    <p>4.4为保障您与智步云上模型网上交易平台的合法权益和正当利益，您在智步云上模型网上交易平台进行作品交易或展示时应当遵守诚实信用原则，不得以发布侵权内容、虚假信息等不正当竞争方式扰乱智步云上模型网上交易平台服务的正常秩序，不得从事与智步云上模型网上交易平台服务无关的行为。
                    </p>
                    <p>4.5您不得采用不正当手段（包括但不限于虚假交易、互换好评等方式）提高自身或他人信用度，或采用不正当手段恶意评价其他用户，降低其他用户的信用度。</p>
                    <p>4.6您不得对智步云上模型网上交易平台上的任何数据做商业性利用，包括但不限于在未经智步云上模型网上交易平台事先书面同意的情况下，以复制、传播等任何方式使用智步云上模型网上交易平台展示的数据资料。</p>
                    <p>4.7您承诺并同意在使用智步云上模型网上交易平台服务过程中，应遵守中华人民共和国地域范围内所有适用的法律、法规、规章、政策、行政命令等（统称为“法律法规”）和社会公序良俗。在任何情况下，智步云上模型网上交易平台一旦合理地认为您的行为可能违反上述法律法规，智步云上模型网上交易平台可以在任何时候，不经事先通知终止向您提供服务。由此导致任何的法律后果，由您承担相应的法律责任。
                    </p>
                    <p>4.8您使用智步云上模型网上交易平台过程中如与其他用户因作品交易产生纠纷，可以请求智步云上模型网上交易平台从中予以协调处理。如您发现其他用户有违法或违反本协议的行为，您可以向智步云上模型网上交易平台反映并要求处理。您因网上交易行为与其他用户产生诉讼的，您可以通过司法部门要求智步云上模型网上交易平台协助提供相关资料。
                    </p>
                    <p>4.9未经智步云上模型网上交易平台书面许可，您不得使用智步云上模型网上交易平台的任何资料以及在交易平台上所展示的任何信息（包括但不限于以存储、使用、发布、复制、发行、网络传播、修改、改编、翻译等形式创作衍生作品或公开展示）。
                    </p>
                    <p>4.10您不得使用以下方式登录智步云上模型网上交易平台或破坏智步云上模型网上交易平台所提供的服务：</p>
                    <p>（1）以任何软件等其它自动方式访问或登录智步云上模型网上交易平台；</p>
                    <p>（2）通过任何方式对智步云上模型网上交易平台内部结构造成或可能造成不合理或不合比例的重大负荷的行为；</p>
                    <p>（3）通过任何方式干扰或试图干扰智步云上模型网上交易平台的正常工作或智步云上模型网上交易平台上进行的任何活动。</p>
                    <p>4.11您未遵守本协议及智步云上模型网上交易平台其他规则、条款，不当注册为智步云上模型网上交易平台用户或超过其民事权利或行为能力范围从事交易的，您与智步云上模型网上交易平台之间的服务协议自始无效。一经发现，智步云上模型网上交易平台有权立即注销该账号，并追究您非法使用智步云上模型网上交易平台服务的一切法律责任。
                    </p>
                    <p>4.12您在使用智步云上模型网上交易平台服务的时候应自觉遵守法律法规、社会主义制度、国家利益、公民合法权益、社会公共秩序、道德风尚和信息真实性等“七条底线”要求，否则我们有权立即采取相应处理措施。您同意并承诺不制作、复制、发布、传播下列信息：
                    </p>
                    <p>（1）违反宪法或法律法规规定的；</p>
                    <p>（2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</p>
                    <p>（3）损害国家荣誉和利益的，损害公共利益的；</p>
                    <p>（4）煽动民族仇恨、民族歧视，破坏民族团结的；</p>
                    <p>（5）破坏国家宗教政策，宣扬邪教和封建迷信的；</p>
                    <p>（6）散布谣言，扰乱社会秩序，破坏社会稳定的；</p>
                    <p>（7）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</p>
                    <p>（8）侮辱或者诽谤他人，侵害他人合法权益的；</p>
                    <p>（9）侵犯他人隐私权、名誉权、肖像权、知识产权或其他专有权利等合法权益内容的； </p>
                    <p>（10）存在可能破坏、篡改、删除、影响智步云上模型网上交易平台正常运行或未经授权秘密获取智步云上模型网上交易平台及其他用户的数据、个人资料的病毒、木马、爬虫等恶意软件、程序代码的；</p>
                    <p>（11）含有法律、行政法规禁止的其他内容的。</p>
                    <p>详细协议和规则请查看《社区发帖、留言、评论规则》</p>
                    <p>如您在使用智步云上模型网上交易平台服务过程中涉及第4.12条中的一项或多项，则需要对自己的行为承担法律责任。承担法律责任的形式包括但不限于：对受到侵害者进行赔偿，以及在智步云上模型网上交易平台首先承担了因您的行为导致的行政处罚或侵权损害赔偿责任等损失（含诉讼费、律师费等相关法律程序费用）后，您应立即给予智步云上模型网上交易平台等额的赔偿。此外，根据具体违法违规情形，智步云上模型网上交易平台有权作出独立判断，立即暂停或终止对您提供部分或全部服务，并向相关机关举报、报案。
                    </p>
                    <p>4.13您按照智步云上模型网上交易平台要求注册即表示您同意接收智步云上模型网上交易平台通过电子邮箱、短信或者其他通讯方式向您发送账户动态，包括但不限于智步云上模型网上交易平台管理信息、更新信息、活动信息、交易信息、促销信息等。
                    </p>
                    <p>4.14您不得为任何非法目的而使用网络服务系统，应遵守所有与网络服务有关的网络协议、规定和程序。不得利用智步云上模型网上交易平台服务进行任何可能对互联网的正常运转造成不利影响的行为，不得利用智步云上模型网上交易平台服务进行任何不利于智步云上模型网上交易平台或损害智步云上模型网上交易平台利益的行为。
                    </p>
                    <p>4.15您在购买的作品（原创作品或授权作品）仅限您在授权书中明确的被授权方使用，作品权利人（作品原创者或取得原创作品合法授权的人）授权被授权方非独占性的使用其作品，被授权方须在智步云上模型网上交易平台的相关规定、授权规则和作品权利人授权的范围内和/或项目中使用，且不得转授权给其他任何第三方使用，也不得超出授权范围和/或项目使用。
                    </p>
                    <p>您不得将购买作品的电子档源文件再出售、转让、发布、供他人下载或以其他方式供他人使用。您一旦确认购买将扣除相关费用，如因您自身原因导致购买错误的，费用不予退还。</p>
                    <p>4.16您不得将通过智步云上模型网上交易平台获取的作品使用在任何违法、色情场合，包括但不限于违法宣传品、违法的医疗保健宣传品、色情淫秽的出版物等，用户不得侵害智步云上模型网上交易平台、作品权利人的合法权益。违规使用原创作品和授权作品的，您将自行承担一切因此造成的经济损失和法律后果。
                    </p>

                </div>
                <div class="protocol-section">
                    <h2>五、智步云上模型网上交易平台的权利与义务</h2>
                    <p>5.1 智步云上模型网上交易平台作为网络服务提供者，为原创数字创意作品的创作者和消费者提供一个交易、交流的平台。智步云上模型网上交易平台络服务涉及的具体作品由上传者提供。</p>
                    <p>5.2
                        智步云上模型网上交易平台有义务在现有技术水平的基础上尽最大努力确保网上交易、交流的正常运行，尽力避免网站服务中断等情形出现，或将服务中断时间限制在最短时间内，保障您合法的交易或交流活动顺利进行。
                    </p>
                    <p>5.3您在使用智步云上模型网上交易平台时如遇到与智步云上模型网上交易平台注册、素材市场交易等有关的问题或情况，可通过在线客服与我们联系，我们将及时回复。</p>
                    <p>5.4
                        智步云上模型网上交易平台在提供服务过程中有权以各种方式投放商业性广告或其他任何类型的商业信息（包括但不限于在智步云上模型网上交易平台的任何位置上投放广告），您同意接受智步云上模型网上交易平台通过电子邮件、站内短信、手机短信、网站公告或其他方式向您发送促销或其他相关商业信息。但广告内容不得影响您正常使用智步云上模型网上交易平台各项功能。
                    </p>
                    <p>5.5您承诺并同意，智步云上模型网上交易平台有权在无须征得您同意的情况下对您的不当行为或其它任何智步云上模型网上交易平台认为应当终止服务的情况作出删除相关信息、终止服务提供等处理。</p>
                    <p>5.6由于网上交易平台的特殊性，智步云上模型网上交易平台没有义务对所有用户的注册数据、所有的交易行为以及与交易有关的其它事项进行实质性审查。如存在下列情况，智步云上模型网上交易平台有权无需征得用户的同意，可根据不同情况选择保留或删除相关信息、限制用户的活动、向用户核实有关情况、发出警告通知、暂时中止、终止及拒绝向该用户提供服务：
                    </p>
                    <p>（1）违反本协议及网站其他规则、规定的；</p>
                    <p>（2）其他用户或任何第三方通知智步云上模型网上交易平台，认为某用户发布的信息、上传的作品可能存在侵权行为；</p>
                    <p>（3）用户或任何第三方告知智步云上模型网上交易平台上有违法或不当行为，并提供相应证据予以证明，智步云上模型网上交易平台认为这些内容或行为具有违法或不当性质的； </p>
                    <p>（4）经国家行政或司法机关的生效法律文书确认存在违法行为的或智步云上模型网上交易平台根据自身的判断，认为存在涉嫌违反法律法规或违反本协议及规则行为的。</p>
                    <p>5.7作品交易过程中任何一方出现违反法律法规、管理规定或协议约定的情形，由双方自行协商解决，智步云上模型网上交易平台无须为此承担法律责任，但智步云上模型网上交易平台有义务秉着客观公正原则提供双方交易中产生的各种证据，以保障交易双方的正当权益不受侵害。若由此导致智步云上模型网上交易平台遭受经济损失的，违约方应全额承担该损失。
                    </p>
                    <p>5.8如有用户发布的下列各类信息，包括但不限于：规避费用、炒作信用、欺诈、扰乱交易秩序、违反公共利益、损害智步云上模型网上交易平台或其它用户合法利益的、侵犯他人知识产权的信息等，智步云上模型网上交易平台有权进行删除或采取其它限制性措施。
                    </p>
                    <p>5.9
                        智步云上模型网上交易平台付出大量成本保证网站正常运行，为作品交易双方及其他一般用户提供第三方网络服务，智步云上模型网上交易平台有权根据智步云上模型网上交易平台相关规则向您收取一定的一般性服务费作为网站维护的费用。
                    </p>
                    <p>5.10 智步云上模型网上交易平台依据本协议及相关规则，可以冻结、先行赔付、退款、处置您缴存在本网站账户内的资金。</p>
                    <p>5.11若您在智步云上模型网上交易平台有违规行为，智步云上模型网上交易平台可以对您处以扣除违约金、严重警告、取消上传或出售资格、冻结交易账户、禁言、扣减信用分等处罚。若您有违法行为的，智步云上模型网上交易平台有权向国家有关部门举报并追究您的法律责任。
                    </p>
                    <p>5.12 智步云上模型网上交易平台不是专业的知识产权机构，只是为用户提供交易、交流平台的网络服务提供者。智步云上模型网上交易平台不具备审查、判断作品是否侵权的能力，也不具备对用户所发布信息的合法性、真实性及其品质，以及用户履行交易的能力等进行审查的能力。但是，为维护原创作者和权利人的合法权益，智步云上模型网上交易平台还是以自身有限的资源，依据自身对法律法规的理解，以普通或非专业人员的知识水平标准对作品进行初步审查。
                    </p>
                    <p>5.13当第三方认为您上传或者发表的作品侵犯其权利，并根据相关法律规定向智步云上模型网上交易平台发送停止侵权通知时，您同意智步云上模型网上交易平台可以根据第三人提供或者智步云上模型网上交易平台掌握的证据自行判断、决定是否删除涉嫌侵权的的信息。删除涉嫌侵权的信息之后，除非收到您符合相关法律规定的书面说明，智步云上模型网上交易平台将不会自动恢复上述删除的信息。
                    </p>
                    <p>5.14 智步云上模型网上交易平台对作品的审查，不能视为智步云上模型网上交易平台对作品版权注意义务的提高。智步云上模型网上交易平台予以审查通过并进行网上销售或展示的作品，不等于智步云上模型网上交易平台对该作品作出不侵权的保证。您明确同意使用智步云上模型网上交易平台所存在的风险将完全由您自己承担，因使用智步云上模型网上交易平台而产生的一切后果也由您自己承担，智步云上模型网上交易平台对您不承担任何责任。如您涉嫌违反有关法律或者本协议之规定，使智步云上模型网上交易平台遭受任何损失，或受到任何第三方的索赔，或受到任何行政管理部门的处罚，您应当赔偿智步云上模型网上交易平台因此造成的损失及（或）发生的费用，包括合理的律师费用。
                    </p>
                </div>
                <div class="protocol-section">
                    <h2>六、代收、代付款</h2>
                    <p>6.1 智步云上模型网上交易平台对您在作品交易的款项和作品推荐销售收益提供代收款服务。</p>
                    <p>6.2您注册完成后，可以查询或管理账户内的预付、应收或应付款，您须提供与账户相对应的经实名认证的支付宝账户。</p>
                    <p>6.3 智步云上模型网上交易平台向您提供交易款代收代付服务，其中包含：</p>
                    <p>（1）代管：代为保管您在智步云上模型网上交易平台账户的充值。</p>
                    <p>（2）代收：代为收取其他智步云上模型网上交易平台用户向您支付的各类款项。</p>
                    <p>（3）代付：代为将您交付代管或代收的款项支付给您指定的其他智步云上模型网上交易平台用户。您同意并知晓：智步云上模型网上交易平台代付后，非经法律程序或者非依本协议之约定，该支付不可逆转。</p>
                    <p>（4）提现：在智步云上模型网上交易平台的收益可以用于提现，当账户满足智步云上模型网上交易平台规定的提现条件时，您可以向智步云上模型网上交易平台做出提现指示，智步云上模型网上交易平台将于收到指示后的3-5个工作日内将相应款项汇入您预留的收款账户中，智步云上模型网上交易平台不接受其他提现方式。提现通常没有手续费，若产生手续费的，另行协商。
                    </p>
                    <p>（5）查询：您可以在智步云上模型网上交易平台中查询您智步云上模型网上交易平台账户名下的交易记录，若认为记录有误的，您可以要求智步云上模型网上交易平台提供管理后台有关收付款的详细记录。但您理解并同意：最终收到款项的服务由您提供的有效账户对应的服务公司（如支付宝账户对应的公司）或者银行等金融机构提供的，如与网站记录不符，请向其进行核实查证。
                    </p>
                    <p>6.4为保障您交易时的合法权益，您理解并同意接受以下规则：</p>
                    <p>（1）您通过智步云上模型网上交易平台预设的交易流程进行交易时，智步云上模型网上交易平台会根据您的指示代收、代付款项，上述指示不可撤回或撤销。</p>
                    <p>（2）交易成功的，若您是作品出卖方，智步云上模型网上交易平台会将本次交易中所得收益存入您在智步云上模型网上交易平台的账户内，满足本协议约定时，收益可提现至支付宝账户。</p>
                    <p>（3）交易不成功的，若您是作品购买方，智步云上模型网上交易平台会及时将此次作品的交易金额返还给您。但受限于银行或支付平台的规定，智步云上模型网上交易平台不对返还到账时间做出承诺。</p>
                    <p>6.5交易未成功或交易违反相关规定，而款项已先行划付至您的智步云上模型网上交易平台账户名下的，您同意智步云上模型网上交易平台有权直接从该账户中扣回款项。若此款项已汇入您的支付宝账户，您同意并承诺在收到智步云上模型网上交易平台通知后7日内将此款项退回。若您未在规定的期限内退还此款项的，智步云上模型网上交易平台有向您追索之权利，因您的原因导致智步云上模型网上交易平台追索的，您应当承担智步云上模型网上交易平台合理的追索费用。
                    </p>
                    <p>6.6因自身过错导致的账户任何损失由您自行承担，该过错包括但不限于：不按照交易提示操作，未及时进行交易操作，遗忘或泄漏密码，密码被他人破解，计算机被他人侵入等。</p>
                    <p>6.7
                        智步云上模型网上交易平台并非银行或其它金融机构，智步云上模型网上交易平台代管、代收或代付的款项不产生任何利息及其他收益。智步云上模型网上交易平台交易下的资金移转均通过支付宝来实现，智步云上模型网上交易平台不因该资金流转途中的风险向您承担责任。
                    </p>
                    <p>6.8您不得将交易用于任何非法目的，同时也不得以任何非法方式在智步云上模型网上交易平台进行交易，不得有侵害他人合法权益之行为，包括但不限于：冒用他人名义及非法使用他人支付宝账户进行交易的，从事任何可能含有电脑病毒或可能侵害本服务系统的行为，其他不适当行为。
                    </p>
                    <p>6.9
                        智步云上模型网上交易平台在发现异常交易或有违反法律规定、本协议约定时，有权不经通知先行对您智步云上模型网上交易平台账户下的正在交易的作品采取暂停、取消交易或冻结账户等限制措施，由此造成的损失，智步云上模型网上交易平台不承担任何赔偿责任。
                    </p>
                </div>
                <div class="protocol-section">
                    <h2>七、交易须知</h2>
                    <p>详情点击查看《智步云上模型网上交易平台买家协议》《智步云上模型网上交易平台付费内容购买协议》</p>
                </div>
                <div class="protocol-section">
                    <h2>八、服务的变更、中断或终止</h2>
                    <p>8.1鉴于网络服务的特殊性，您同意智步云上模型网上交易平台可自行决定在发出通知或不发出通知的情况下，随时变更、中断或终止部分或全部的网络服务。服务终止后，智步云上模型网上交易平台没有义务为您保留原账户或与之相关的任何信息。当智步云上模型网上交易平台变更、中断或终止全部网络服务时，智步云上模型网上交易平台不提供赔偿、退款服务。
                    </p>
                    <p>8.2
                        智步云上模型网上交易平台需要定期或不定期地对提供网络服务的平台或相关的设备进行检修或者维护，如因此类情况而造成收费网络服务在合理时间内的中断，智步云上模型网上交易平台无需为此承担任何责任，但智步云上模型网上交易平台应尽可能事先通告。
                    </p>
                    <p>8.3用户提出注销智步云上模型网上交易平台注册用户身份，需经智步云上模型网上交易平台审核同意，注销该注册用户，用户即解除与智步云上模型网上交易平台的协议关系，但智步云上模型网上交易平台仍保留下列权利：</p>
                    <p>（1）智步云上模型网上交易平台有权在法律、法规、规章规定的时间内保留该用户的资料，包括但不限于用户资料、交易记录等；</p>
                    <p>（2）若用户注销前在智步云上模型网上交易平台交易平台上存在违法行为或违反本协议的行为，智步云上模型网上交易平台仍可行使本协议及相关规则所规定的权利，追究该用户的法律责任。</p>
                    <p>8.4如遇下列情况，智步云上模型网上交易平台可以通过注销用户账号的方式终止服务：多次违反本协议及相关规则的、注册资料内容虚假或冒用他人信息的、存在其它智步云上模型网上交易平台认为需终止服务的情况。</p>
                </div>
                <div class="protocol-section">
                    <h2>九、隐私保护</h2>
                    <p>9.1 智步云上模型网上交易平台非常重视您的隐私和个人信息保护，我们深知个人信息对您的重要性，并会尽全力保护您的信息安全可靠。我们承诺，我们将按业界成熟的安全标准，采取相应的安全保护措施来保护您的信息。
                    </p>
                    <p>9.2 智步云上模型网上交易平台保证不对外公开或向第三方提供单个用户的注册资料及用户在使用网络服务时存储在智步云上模型网上交易平台的非公开内容，但下列情况除外：</p>
                    <p>（1）获得用户本人明确授权的；</p>
                    <p>（2）违反中国法律、法规、规章、规定或者智步云上模型网上交易平台规则的情况，需要向第三方披露；</p>
                    <p>（3）根据法律的有关规定，或者行政、司法机关的要求，向第三方或者行政、司法机关披露；</p>
                    <p>（4）为提供您所要求的产品和服务，而必须和第三方分享您的个人信息；</p>
                    <p>（5）因开具发票等原因的需要，向交易对方披露；</p>
                    <p>（6）因需要出具作品授权书，向交易对方披露；</p>
                    <p>（7）智步云上模型网上交易平台根据法律或者本网站规定认为合适的披露。</p>
                    <p>9.3 智步云上模型网上交易平台可能会与第三方合作向用户提供相关的网络服务，在此情况下，如该第三方同意承担与智步云上模型网上交易平台同等的保护用户隐私的责任，并承诺仅在约定合作的范围内使用，则智步云上模型网上交易平台视情况有权将用户的注册资料等提供给该第三方，您对此表示同意并授权。
                    </p>
                    <p>9.4在不对外透露单个用户隐私资料的前提下，智步云上模型网上交易平台有权按照国家有关法律法规的要求（如匿名化或者去标识化等）对整个用户数据库进行分析并对用户数据库的分析结果进行利用。</p>
                    <p>9.5更多关于智步云上模型网上交易平台隐私保护的内容，请参见《智步云上模型网上交易平台隐私政策》。</p>
                </div>
                <div class="protocol-section">
                    <h2>十、不可抗力及免责声明</h2>
                    <p>10.1
                        智步云上模型网上交易平台是为用户提供交易及交流服务的平台，对于用户所发布的信息的合法性、真实性及其品质，以及用户履行交易的能力等，智步云上模型网上交易平台不负任何担保责任。智步云上模型网上交易平台也不对用户所提供的作品及其资料、已通过身份认证的用户及其所提供的身份信息作任何合法性、真实性的保证。因使用智步云上模型网上交易平台络服务所存在的风险将完全由自己承担，智步云上模型网上交易平台对用户不承担责任。
                    </p>
                    <p>10.2 智步云上模型网上交易平台对用户在网站任何区域提供的任何陈述、声明或内容均不承担责任。用户在智步云上模型网上交易平台上发表的任何言论均不代表智步云上模型网上交易平台的观点或立场，智步云上模型网上交易平台对用户或任何第三方发布、存储或上传的任何内容或因其引起的任何损失或损害，均不承担责任。对用户可能遇到的任何错误、中伤、诽谤、诬蔑、不作为、谬误、淫秽、色情或亵渎，智步云上模型网上交易平台也不承担责任。
                    </p>
                    <p>10.3基于网络服务的特殊性，智步云上模型网上交易平台将尽可能保证网络的正常服务，但对于因不可抗力或智步云上模型网上交易平台不能控制的原因造成的网络服务中断或其它缺陷，智步云上模型网上交易平台不承担任何责任，但将尽力减少因此而给您造成的损失和影响。
                    </p>
                    <p>10.4对于智步云上模型网上交易平台向您提供的下列产品或者服务的质量缺陷本身及其引发的任何损失，智步云上模型网上交易平台无需承担任何责任：免费网络服务、赠送的产品或服务、收费服务附赠的各种产品或服务。</p>
                    <p>10.5您理解并同意，关于我们服务及相关服务，我们不提供任何种类的明示或暗示担保或条件，包括但不限于商业适售性、特定用途适用性等。您对我们服务及相关服务的使用行为应自行承担相应风险。</p>
                    <p>10.6因不可抗力或者其他意外事件，使得本协议的履行不可能、不必要或者无意义的，双方均不承担责任。本协议所称之不可抗力是指双方不能控制、不可预见或及时预见亦无法避免的事件（包括但不限于政府行为、自然灾害、黑客攻击、病毒感染、第三方服务故障、网络平台及平台软件服务器崩溃、电信部门技术管制、战争或任何其他类似事件），该事件妨碍、影响或延误一方根据本协议履行其全部或部分义务。
                    </p>
                </div>
                <div class="protocol-section">
                    <h2>十一、知识产权</h2>
                    <p>11.1
                        智步云上模型网上交易平台及智步云上模型网上交易平台所使用的任何相关软件、程序、内容，包括但不限于作品、图片、档案、资料、网站构架、网站版面的布局、网页设计、经由智步云上模型网上交易平台或广告商向您呈现的广告或资讯，均由智步云上模型网上交易平台或其它权利人依法享有相应的知识产权及其他权利，包括但不限于著作权、商标权、专利权或其它专属权利等，受到相关法律的保护。未经智步云上模型网上交易平台或权利人书面明示授权，您不得以包括但不限于修改、出租、出借、出售、散布等方式使用智步云上模型网上交易平台及智步云上模型网上交易平台所使用的上述任何作品和资源，或根据上述作品和资源制作成任何种类产品。
                    </p>
                    <p>11.2
                        您在任何情况下都不要私自使用我们的包括但不限于我们的任何商标、服务标记、商号、域名、网站名称或其他显著品牌特征等（统称为“标识”）。未经我们事先书面同意，您不得将本条款前述标识以单独或结合任何方式展示、使用或申请注册商标、进行域名注册等，也不得实施向他人明示或暗示有权展示、使用、或其他有权处理该些标识的行为。由于您违反本协议使用我们上述商标、标识等给我们或他人造成损失的，由您承担全部法律责任。
                    </p>
                    <p>11.3您不得经由非智步云上模型网上交易平台所提供的界面使用智步云上模型网上交易平台，不得在除智步云上模型网上交易平台以外的网站上对智步云上模型网上交易平台建立镜像</p>
                    <p>11.4您保证上传到智步云上模型网上交易平台所有作品均为自己原创或取得必要的授权，不存在侵权行为。</p>
                    <p>11.5原创作品权属归著作权人本人所有，受相关法律保护。购买方购买作品的，将根据该作品具体的授权许可方式取得相应的授权，购买方下载、使用作品应在授权范围内和/或项目中使用。且您在智步云上模型网上交易平台所销售的视频作品均不包含该作品为展示效果所添加的音频、字体文件，该视频作品的授权亦不包括对视频所附带音频、字体文件的使用，经您特别授权的除外。
                    </p>
                </div>
                <div class="protocol-section">
                    <h2>十二、通知送达</h2>
                    <p>12.1本协议项下，智步云上模型网上交易平台对于您所有的通知均可通过网页公告、智步云上模型网上交易平台站内短信、电子邮件、手机短信或常规的信件传送等方式中的任何一种进行，且均于发送成功之时视为已送达收件人。</p>
                    <p>12.2您对于智步云上模型网上交易平台的通知应当通过智步云上模型网上交易平台对外正式公布的通信地址、传真号码、电子邮件地址等联系信息进行送达。</p>
                </div>
                <div class="protocol-section">
                    <h2>十三、保密</h2>
                    <p>对讨论、签订、执行本协议中所获悉的属于对方的、且无法自公开渠道获得的文件及资料（包括但不限于商业秘密、公司计划、运营活动、财务信息、技术信息、经营信息及其他商业秘密）予以保密。未经该资料和文件的提供方同意，不得向第三方泄露该文件资料的全部或者部分内容。但法律、法规、规章另有规定或者双方另有约定的除外。
                    </p>
                </div>
                <div class="protocol-section">
                    <h2>十四、法律适用与争议解决</h2>
                    <p>14.1本协议及其规则的有效性、履行及争议解决等所有事宜，均适用中华人民共和国法律法规及相关规定。</p>
                    <p>14.2就本协议及协议所附规则的内容或其执行发生任何争议，双方应尽力友好协商解决；协商不成时，任何一方均应向北京智步云上科技有限公司所在地人民法院提起诉讼。</p>
                    <p>14.3 智步云上模型网上交易平台有权决定是否参与调处用户之间因作品交易或作品定制产生的争议。</p>
                    <p>14.4
                        智步云上模型网上交易平台有权受理并调处用户之间在“素材市场”因作品交易产生的争议，同时有权单方面以非专业交易者的知识水平标准独立判断用户的投诉及索偿是否成立。若智步云上模型网上交易平台判断索偿成立，则智步云上模型网上交易平台有权使用被投诉用户账户内未提现的金额进行相应偿付。智步云上模型网上交易平台没有使用自用资金进行偿付的义务，但若进行了该项支付，被投诉用户应及时赔偿本网站的全部损失，否则智步云上模型网上交易平台有权通过前述方式抵减相应资金或权益，如仍无法弥补损失，则智步云上模型网上交易平台保留继续追偿的权利。因智步云上模型网上交易平台非司法机关，用户完全理解并承认，智步云上模型网上交易平台对证据的鉴别能力及对纠纷的处理能力有限，受理交易争议完全是基于用户之委托，不保证争议处理结果符合期望。
                    </p>
                </div>
                <div class="protocol-section">
                    <h2>十五、附则</h2>
                    <p>15.1根据本协议制定的各项服务的实施细则以及其他以智步云上模型网上交易平台名义发布的制度、办法、规定、公告等均属本协议不可分割的部分。</p>
                    <p>15.2本协议中的标题仅为方便阅读而设，并不影响本协议中任何规定的含义或解释。</p>
                    <p>15.3您和我们均是独立的主体，在任何情况下本协议不构成我们对您的任何形式的明示或暗示担保或条件，双方之间亦不构成代理、合伙、合营或雇佣关系。</p>
                    <p>15.4本协议项下的“您”是指与智步云上模型网上交易平台签订《智步云上模型网上交易平台服务协议》并完成注册流程的用户。</p>
                    <p>15.5本协议适用所有在智步云上模型网上交易平台注册的用户。</p>
                    <p>15.6本协议的最终解释权归北京智步云上科技有限公司所有。</p>
                </div>
                <!-- 更多协议内容... -->
            </div>
        </div>
        <!-- 底部版权：固定在页面底部 -->
        <div class="protocol-footer-wrapper">
            <!-- <Bottom></Bottom> -->
        </div>
    </div>
</template>

<script>
import Bottom from '../../components/Footer.vue';
export default {
    name: 'ServiceProtocol',
    components: {
        Bottom
    },
    methods: {
        goLogin() {
            this.$router.push('/Login');
        },
    }
}
</script>

<style lang="less" scoped>
// 页面外层容器：设置全局背景色，确保占满整个视口
.protocol-page-wrapper {
    width: 100%;
    min-height: 100vh;
    background-color: #232323; // 两侧背景色
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

// 主体容器：保持原有宽度，内容居中
.protocol-container {
    max-width: 1200px;
    width: 100%;
    margin: 0 auto;
    padding: 30px;
    box-sizing: border-box; // 确保padding不影响宽度
    flex: 1; // 占满除底部外的剩余空间
}

.protocol-header {
    text-align: center;
    margin-bottom: 30px;
    padding-bottom: 20px;
    border-bottom: 1px solid #444; // 适配深色背景的分隔线

    h1 {
        font-size: 24px;
        color: #E3E3E3;
        font-weight: 600;
    }
}

.protocol-content {
    font-size: 16px;
    line-height: 1.8;
    color: #ACACAC;

    .protocol-section {
        margin-bottom: 25px;

        h2 {
            font-size: 18px;
            color: gainsboro;
            margin-bottom: 10px;
            font-weight: bold;
        }

        p {
            margin-bottom: 10px;
            text-indent: 2em;
        }
    }
}
</style>